import { render, staticRenderFns } from "./MassiveImportSupervisorProjectDetailModal.vue?vue&type=template&id=0d7b8885&scoped=true&"
import script from "./MassiveImportSupervisorProjectDetailModal.vue?vue&type=script&lang=js&"
export * from "./MassiveImportSupervisorProjectDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./MassiveImportSupervisorProjectDetailModal.vue?vue&type=style&index=0&id=0d7b8885&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b8885",
  null
  
)

export default component.exports